import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=c6bea888&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bea888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c6bea888', component.options)
    } else {
      api.reload('c6bea888', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=c6bea888&scoped=true&", function () {
      api.rerender('c6bea888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/partners/Settings.vue"
export default component.exports